import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import './index.css';
import config from '../../config/config';
import DiabetesPatientGroomingForm from "./DiabetesPatientGroomingForm";
import DiabetesPatientRoomingForm from "./DiabetesPatientRoomingForm";


import img1 from '../../../src/images/patient-icon.svg'
import img2 from '../../../src/images/cross-icon.svg'
import img3 from '../../../src/images/analysis-profile.svg'
import img4 from '../../../src/images/calendar2.svg'
import img12 from '../../../src/images/3dots.svg'
import img5 from '../../../src/images/insights1.svg';
import img8 from '../../../src/images/home2.svg';
import img9 from '../../../src/images/Icon (5).svg';
import img10 from '../../../src/images/notification.svg';
import img11 from '../../../src/images/Calendar3.svg';
import img13 from '../../../src/images/arr-down.svg'
import img14 from '../../../src/images/patient-icon.svg'; // Patients Icon
import img15 from '../../../src/images/glucose-trends.svg'

import img16 from '../../../src/images/home2.svg';
import img17 from '../../../src/images/Icon (5).svg';
import img18 from '../../../src/images/notification.svg';
import img19 from '../../../src/images/Calendar3.svg';
import img20 from '../../../src/images/Icon (6).svg';




function GroomingPage() {
   const { patientId } = useParams(); // Capture patientId from the route
    const navigate = useNavigate();
    const location = useLocation();
    const { patientName, patientAge, patientCondition, groomingProgress, appointmentDate, appointmentTimeslot} = location.state || {};
    const [patientData, setPatientData] = useState(null);
    const [nextAppointment, setNextAppointment] = useState(null);

    const [formData, setFormData] = useState({
        height: '',
        weight: '',
        bloodPressure: '',
        bloodSugar: '',
        cholesterol: '',
        a1cLevel: '',
        allergies: '',
        medications: '',
        symptoms: '',
        lifestyleFactors: '',
        mealPlan: '',
    });
    const backendURL = `${config.backendServerHost}`;

    // Place console.log statements to debug received state
    console.log('Received state:', location.state);
    console.log('Extracted Patient Name:', patientName);
    console.log('Extracted Patient Age:', patientAge);
    console.log('Extracted Patient Condition:', patientCondition);
    console.log('Extracted Patient Grooming status:', groomingProgress);
    console.log('Extracted Patient Appointment Date:', appointmentDate);
    console.log('Extracted Patient Appointment Timeslot:', appointmentTimeslot);

    useEffect(() => {
        if (!patientName) {
            console.error('Patient name is missing.');
            return;
        }

        // Fetch patient data by name
        fetch(`${backendURL}/patients/api/patients`)
            .then((res) => res.json())
            .then((data) => {
                const foundPatient = data.find((patient) => patient.name === patientName);
                if (foundPatient) {
                    setPatientData(foundPatient); // Set the patient data
                } else {
                    console.error(`Patient with name "${patientName}" not found.`);
                }
            })
            .catch((error) => console.error('Error fetching patients:', error));
    }, [backendURL, patientName]);

   useEffect(() => {
        if (!patientName) return;

        // Fetch the next appointment for the selected patient
        fetch(`${backendURL}/patients/api/appointments?patientName=${patientName}`)
            .then((res) => {
                if (!res.ok) {
                    throw new Error('Failed to fetch appointment data');
                }
                return res.json();
            })
            .then((data) => {
                setNextAppointment(data.date || 'No upcoming appointments');
            })
            .catch((error) => {
                console.error('Error fetching next appointment:', error);
                setNextAppointment('Error fetching appointment data');
            });
    }, [backendURL, patientName]);


    // Handle form input changes
 const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    // Handle form submission
   const handleSubmit = (e) => {
        e.preventDefault();
        fetch(`${backendURL}/patients/api/grooming-status/${patientId}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                ...formData,
                status: 'Completed',
                progress: 100,
            }),
        })
            .then((res) => res.json())
            .then(() => {
                alert('Grooming data submitted successfully!');
                navigate('/appointments');
            })
            .catch((error) => console.error('Error submitting grooming data:', error));
    };

    if (!patientData) {
        return <p>Loading patient data...</p>;
    }

const handleGroomingClick = async (patientName, groomingProgress) => {
    try {
        const response = await fetch(`${backendURL}/patients/api/patients`);
        const patientsData = await response.json();
        const patient = patientsData.find((p) => p.name === patientName);
        if (patient) {
            navigate('/grooming', {
                state: {
                    patientName: patient.name,
                    patientAge: patient.age,
                    patientCondition: patient.type,
                    groomingProgress, // Include grooming progress
                },
            });
        } else {
            console.error('Patient not found:', patientName);
        }
    } catch (error) {
        console.error('Error fetching patient data:', error);
    }
};

    return (
        <div className="dashboard_container ai-analysis-container">


            {/* Patient Information */}
            <div className='patient-navbar'>
                <div></div>
                <div className='patient-icon'>
                <img src={img1} alt="" /><span>Patient</span></div>
                <div><img src={img2} alt="" /></div>
            </div>
            <div className='patient_info_card'>
                <div className='patient_info_content'>
                    <div><img src={img3} alt="" /></div>
                    <div>
                        <h3>{patientName}</h3>
                        <h4>Age: {patientAge}<br />Condition: {patientCondition}</h4>
                    </div>
                </div>

                <div className='ai-analysis-wrapper patient_buttons'>
                    <div className='aianalysis-btn3'><button>Call</button></div>
                    <div className='aianalysis-btn3'><button>SMS</button></div>
                </div>
            </div>

            <div className='appointment-content'>
                <div className='appointment-text'>
                    <div><img src={img4} alt="" /></div>
                    <div>
                        <h3>Next appointment:</h3>
                        <h4>
                            {appointmentDate && appointmentTimeslot ? `${appointmentDate} at ${appointmentTimeslot}` : 'No upcoming appointments'}
                        </h4>
                    </div>
                </div>
                <div>
                    <img src={img12} alt="" />
                </div>
            </div>



            <div className="grooming-progress-wrapper">
                <h2>Grooming Data for {patientData.name}</h2>
                {/* Grooming Progress Bar */}
                <p><strong>Grooming Completion Status:</strong> ${groomingProgress}%</p>

                <div
                    className="grooming-progress-bar"
                    style={{
                        width: `${groomingProgress}%`,
                        height: "20px",
                        background:
                            groomingProgress > 60
                                ? "yellow"
                                : groomingProgress === 100
                                ? "green"
                                : "red",
                        borderRadius: "5px",
                        position: "relative",
                        marginBottom: "20px",
                    }}
                >
                    <span
                        style={{
                            position: "absolute",
                            right: "5px",
                            top: "50%",
                            transform: "translateY(-50%)",
                            fontWeight: "bold",
                            color: "black",
                        }}
                    >
                        {groomingProgress}%
                    </span>
                </div>
            </div>
 

            {/* Grooming Form for Patient */}

            <h2>Grooming Data for {patientName}</h2>
            <DiabetesPatientGroomingForm patientName={patientName} />

            {/* rooming questionnaire form  */}
            <h2>Rooming Data for {patientName}</h2>
            <DiabetesPatientRoomingForm  patientName={patientName}/>


<div className="footer_container_wrapper">
                <div className="footer_container">
                    <div className="footer_icon" onClick={() => navigate('/dashboard-page')}>
                        <img src={img8} alt="Home Icon" />
                    </div>
                    <div className="footer_icon" onClick={() => navigate('/analysis')}>
                        <img src={img9} alt="Analytics Icon" />
                    </div>
                    <div className="footer_icon" onClick={() => navigate('/alerts')}>
                        <img src={img10} alt="Notification Icon" />
                    </div>
                    <div className="footer_icon" onClick={() => navigate('/appointments')}>
                        <img src={img11} alt="Calendar Icon" />
                    </div>
                    <div className="footer_icon" onClick={() => navigate('/Aianalysis1')}>
                        <img src={img14} alt="Patient Icon" />
                    </div>
                </div>
            </div>



        </div>
    );
}

export default GroomingPage;

